/**
 * Exceldownload working with NSWOW2 Tables
 */
class XTableNamer {
  constructor() {

    const elements = Array.prototype.slice.call(document.querySelectorAll('.wordpress-content .ns-table-wrap, .wordpress-content .ns-title-h1, .wordpress-content .ns-title-h2, .wordpress-content .accordion-title'));
    let h1;
    let h2;
    let c;
    const pageTitle = document.querySelector('.header__top-title');

    elements.forEach(element => {
      const className = element.classList[0];

      switch (className) {
        case "ns-title-h1":
          const span = element;
          if (!!span) {
            h1 = span.innerText;
          }
          c = 0;
          break;
        case "ns-title-h2":
          if (!!element.innerText.trim()) {
            h2 = element.innerText;
            c = 0;
          }
          break;
        case "accordion-title":
          const spanL = element.querySelector('span:last-child');
          if (!!spanL.innerText.trim()) {
            h2 = spanL.innerText;
            c = 0;
          }
          break;
        case "ns-table-wrap":
          let title = '';
          let fileTitle = '';

          let xlsxTitle = element.querySelector('.ns-table-xlsx-title');
          if (xlsxTitle) {
            title = xlsxTitle.innerText.trim();
            fileTitle = title.replace(/\s/g, '_');
            xlsxTitle.remove();
          } else {
            if (!!pageTitle) {
              title += pageTitle.innerText + ' – ';
            }

            if (!!h1) {
              title += h1.trim();
              fileTitle += h1.trim();
            }

            if (!isNaN(fileTitle.charAt(1))) {
              fileTitle = fileTitle.charAt(0) + fileTitle.charAt(1) + " " + fileTitle.substring(2);
            } else if (!isNaN(fileTitle.charAt(0))) {
              fileTitle = fileTitle.charAt(0) + " " + fileTitle.substring(1);
            }

            if (!isNaN(title.charAt(1))) {
              title = title.charAt(0) + title.charAt(1) + " " + title.substring(2);
            } else if (!isNaN(title.charAt(0))) {
              title = title.charAt(0) + " " + title.substring(1);
            }
          }
          element.dataset.xTitle = title;
          element.dataset.xFileTitle = fileTitle;
          c++;
          break;
        }
    });
  }
}

export default XTableNamer;
